import { DbLotteryFilter } from "./db-lottery-filter";
import { Lottery } from "../../_shared/lottoloca-commom/lottery-modex";
import { reject } from "q";
import { DbLottery } from "./db-lottery";
import { DbListBase } from "./db-list-base";
import { DbTaskCategory } from './db-customer-lottery';
import { IDatabase } from '../database-cast/IDatabase';


export class DbTasks extends DbListBase<any> {
    database: IDatabase;
    // getCategory(arg0: string) {
    //     throw new Error("Method not implemented.");
    // }

    constructor(docReference: IDatabase) {
        super(docReference.collection(`tasks`));

        this.database = docReference;
   
    }

    public getCategory(category:string)
    {
        return new DbTaskCategory( category, this._collection);
    }
}



export class DbLotteries extends DbListBase<Lottery> {


  //  private _collection: ICollectionReference;

    constructor(docReference: IDatabase) {
        super(docReference.collection(`config-lotteries`));
   
    }

    public selectAll(): Promise<Lottery[]> {
        let promise: Promise<any[]> = new Promise((resolve, reject) => {

            this._collection
                .get()
                .then((querySnapshot: any) => {

                    let lotteries: Array<Lottery> = [];
                    querySnapshot.forEach(doc => {
                        let param = doc.data();

                        lotteries.push(param);
                    });


                    resolve(lotteries);

                })
                .catch(error => {
                    reject(error);
                });

        });
        return promise;
    }


    public update(lottery: Lottery): Promise<Lottery> {

        let promise = new Promise<Lottery>((resolve, reject) => {

            this._collection
                .doc(lottery.id)
                .set(Object.assign({}, lottery))
                .then(() => {
                    resolve(lottery);
                })
                .catch(error => {
                    reject(error);
                });
        });

        return promise;
    }


    public getLottery(lotteryId:string): DbLottery {
        return new DbLottery(lotteryId, this._collection);

    }

}